module.exports = __webpack_public_path__ + "img/rnd4.4adc7180.jpg";